import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  zh: {
    "取消": '取消',
    "确定": '确定',
    "发送": '发送',
    "系统通知": '系统通知',
    "关闭": '关闭',
    "图片": '图片',
    "文件": '文件',
    "表情": '表情',
    "视频": '视频',
    "录制": '录制',
    "拍照": '拍照',
    TUIChat,
    Component,
    time,
    AIDesk,
  },
};

export default messages;
